module.exports = __webpack_public_path__ + "static/media/features-split-image-02.2583874b.png";